import { InlineText2 } from '@cian/ui-kit';
import * as React from 'react';
import { LinkButton } from '../../../../../common/LinkButton';
import { ErrorWrapper } from '../ErrorWrapper';

interface IPriceEmptyErrorProps {
  onAddPriceClick(): void;
}

export const PriceEmptyError = ({ onAddPriceClick }: IPriceEmptyErrorProps) => {
  return (
    <ErrorWrapper>
      <InlineText2 textAlign="center">
        Добавьте цену, чтобы <br /> увидеть конкуренцию
      </InlineText2>

      <LinkButton marginTop={8} onClick={onAddPriceClick}>
        Добавить цену
      </LinkButton>
    </ErrorWrapper>
  );
};
